module.exports = __webpack_public_path__ + "img/dock-window.6f88021a.svg";